import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '@/stores/authStore';
import { asset } from '@/lib/asset';

export function TopBar() {
  const { t } = useTranslation();
  const user = useAuthStore((s) => s.user);
  const initial = (user?.firstName ?? 'J').charAt(0).toUpperCase();

  return (
    <header className="sticky top-0 z-30 px-3 pt-[max(env(safe-area-inset-top),0.75rem)] pb-2">
      <div
        className="flex items-center gap-3 rounded-2xl px-3 py-2.5 surface-glass"
      >
        <div className="relative shrink-0">
          <img
            src={asset('/logo.jpg')}
            alt="JohnCalliano Lounge"
            className="w-10 h-10 rounded-full object-cover"
          />
          {/* Emerald halo — a faint ring around the crest, paired with the
              same green used by the parking accent and "Сейчас открыто". */}
          <span
            aria-hidden
            className="pointer-events-none absolute inset-0 rounded-full"
            style={{
              boxShadow:
                '0 0 0 1px rgba(110, 169, 135, 0.45), 0 0 14px -3px rgba(110, 169, 135, 0.5)',
            }}
          />
        </div>

        <div className="flex-1 min-w-0">
          <div className="headline text-[14px] truncate uppercase tracking-[0.04em]">
            {t('app.title')}
          </div>
          <div className="font-mono text-[9.5px] uppercase tracking-[0.22em] text-white/45 truncate mt-1">
            {t('app.subtitle')}
          </div>
        </div>

        <Link
          to="/profile"
          aria-label="profile"
          className="group relative w-10 h-10 shrink-0 rounded-full inline-flex items-center justify-center overflow-hidden"
          style={{
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid var(--line-2)',
          }}
        >
          <span
            aria-hidden
            className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
            style={{ boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.35)' }}
          />
          {user?.photoUrl ? (
            <img src={user.photoUrl} alt="" className="w-full h-full object-cover" />
          ) : (
            <span className="font-display text-sm text-white/90">{initial}</span>
          )}
        </Link>
      </div>
    </header>
  );
}
